export const keyToPathMap = {
    announcement: "/admin/announcement",
    eventVideos: "/admin/event",
    news: "/admin/news",
    academicAuditReport: "/admin/iqac/academic-audit-template",
    academicCalendar: "/admin/academic-calendar",
    bestPractices: "/admin/iqac/best-practices",
    assessmentCriteria: "/admin/iqac/assessment-criteria",
    minutes: "/admin/iqac/minutes-page",
    aqars: "/admin/iqac/aqars-page",
    calendarHandbook: "/admin/iqac/calender-handbook-page",
    outcomes: "/admin/iqac/outcomes-page",
    nirf: "/admin/iqac/nirf-page",
    aishe: "/admin/iqac/aishe-page",
    sss: "/admin/iqac/sss-page",
    newsLetter: "/admin/alumini/newsletter",
    distinctiveness: "/admin/iqac/distinctiveness-page",

    studentsFeedback: "/admin/feedback/students-feedback-page",
    teachersFeedback: "/admin/feedback/teachers-feedback-page",
    employeesFeedback: "/admin/feedback/employees-feedback-page",

    helpDeskStudentParent: "/admin/helpdesk/students-parents-page",
    helpDeskVisitor: "/admin/helpdesk/visitors-page",


    contact: "/admin/contact-messages",
    admissionForms: "/admin/admission/application-for-admisssion",
    ombudsmanGrievance: "/admin/ombudsman-page",
    achieversGallery: "/admin/alumini/achievers-gallery",
    staffApplications: "/admin/staff-application-page",
    gallery: "/admin/gallery-page"
};

export const groupedCounts = {
    "Home Page": [
        { title: "Announcements", key: "announcement" },
        { title: "Event Videos", key: "eventVideos" },
        { title: "News", key: "news" },
    ],
    Reports: [
        { title: "Academic Audit Report", key: "academicAuditReport" },
        { title: "Academic Calendar", key: "academicCalendar" },
        { title: "Best Practices", key: "bestPractices" },
        { title: "Assessment Criteria", key: "assessmentCriteria" },
        { title: "Minutes", key: "minutes" },
        { title: "AQARS", key: "aqars" },
        { title: "Calendar Handbook", key: "calendarHandbook" },
        { title: "Outcomes", key: "outcomes" },
        { title: "NIRF", key: "nirf" },
        { title: "AISHE", key: "aishe" },
        { title: "SSS", key: "sss" },
        { title: "Newsletter", key: "newsLetter" },
        { title: "Distinctiveness", key: "distinctiveness" },
    ],
    Feedback: [
        { title: "Students", key: "studentsFeedback" },
        { title: "Staffs", key: "teachersFeedback" },
        { title: "Parents", key: "employeesFeedback" }
    ],
    HelpDesk: [
        { title: "Students & Parents", key: "helpDeskStudentParent" },
        { title: "Visitors", key: "helpDeskVisitor" }
    ],
    "General Management": [
        { title: "Contact Messages", key: "contact" },
        { title: "Admission Forms", key: "admissionForms" },
        { title: "Ombudsman Grievances", key: "ombudsmanGrievance" },
        { title: "Achievers Gallery", key: "achieversGallery" },
        { title: "Staff Applications", key: "staffApplications" },
        { title: "Gallery", key: "galleryImages" },
    ]
};
